import { useQuery } from 'react-query';
import { queryKeys } from './query-keys';
import { ManualTemplateRequest } from './types';
import { ManualTemplatesApi } from '.';

export const useGetManualTemplateByType = (request: ManualTemplateRequest) => {
  return useQuery({
    queryKey: queryKeys.manualTemplateByType(request),
    queryFn: () => ManualTemplatesApi.getManualTemplateByType(request.templateType, request.locationId),
    enabled: !!request.locationId && !!request.templateType,
    retry: 1,
    select: (data) => {
      if (data?.Template) {
        // Replace template message tags with the expected format of using an underscore instead of a space between words
        const updatedContent = data.Template.replace(/{\s*([\w\s]+?)\s*}/g, (_, tag) => {
          const normalizedTag = tag.trim().replace(/\s+/g, '_');
          return `{${normalizedTag}}`;
        });
        return { ...data, Template: updatedContent };
      }
      return data;
    },
  });
};
